(() => {
  if (window.__bisMgr) return;

  const isFR = (() => {
    try {
      if (window.Shopify?.locale) return String(Shopify.locale).toLowerCase().startsWith('fr');
    } catch {}
    const lang = document.documentElement.lang || '';
    return lang.toLowerCase().startsWith('fr');
  })();

  const T = {
    title: isFR ? 'ALERTE STOCK' : 'BACK IN STOCK',
    desc: isFR ? 'Recevez un email dès que votre taille est de retour.' : 'Get an email when your size is back.',
    email_ph: isFR ? 'Votre e-mail' : 'Your email',
    btn: isFR ? 'Prévenez-moi' : 'Notify me',
    ok1: isFR ? 'Inscription enregistrée.' : 'Request saved.',
    ok2: isFR ? 'Vous serez averti dès que disponible.' : 'We will notify you when available.',
    small: isFR ? 'Nous n’utilisons votre email que pour cette alerte.' : 'We only use your email for this alert.',
    fill: isFR ? 'Veuillez remplir tous les champs.' : 'Please fill all fields.',
    err: isFR ? 'Erreur lors de l’enregistrement de votre demande.' : 'An error occurred while saving your request.',
    sizeWord: isFR ? 'Taille ' : 'Size '
  };

  const mgr = (window.__bisMgr = {
    booted: false,

    ensureMarkup() {
      if (document.getElementById('back-in-stock-popup')) return;

      // overlay
      const overlay = document.createElement('div');
      overlay.id = 'overlay';
      overlay.className = 'overlay';
      overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);display:none;z-index:9998;';
      document.body.appendChild(overlay);

      // popup
      const wrap = document.createElement('div');
      wrap.id = 'back-in-stock-popup';
      wrap.className = 'back-in-stock-popup';
      wrap.style.cssText = 'display:none;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:9999;width:90%;max-width:450px;';
      wrap.innerHTML = `
        <div class="popup-content" style="background:#fff;padding:25px;text-align:left;box-shadow:0 2px 8px rgba(0,0,0,.2);position:relative;">
          <div class="popup-header" style="display:flex;justify-content:space-between;align-items:center;margin-bottom:15px;font-size:18px;">
            <p id="popup-title" style="margin:0;font-weight:500;font-size:26px;text-transform:uppercase;">${T.title}</p>
            <span id="close-popup" class="close" style="font-size:50px;cursor:pointer;position:absolute;bottom:83%;right:10px;">&times;</span>
          </div>

          <p class="description" style="font-size:14px;margin-bottom:20px;">${T.desc}</p>
          <p id="product-name" style="font-size:14px;font-weight:bold;padding:10px 0;margin:15px 0;"></p>

          <form method="post" id="back-in-stock-form" style="text-align:left;margin-bottom:20px;">
            <input type="email" id="customer-email" name="contact[email]" placeholder="${T.email_ph}" required
                   style="width:100%;padding:10px;border:1px solid #ccc;border-radius:0;margin-bottom:15px;font-size:14px;">
            <input type="hidden" id="productId" name="product_id" value="">
            <input type="hidden" id="variantId" name="variant_id" value="">
            <button type="submit" id="back-in-stock-btn" class="back-in-stock-btn"
                    style="width:100%;padding:10px 20px;background:#000;color:#fff;border:none;border-radius:0;cursor:pointer;font-size:16px;margin-top:10px;">
              ${T.btn}
            </button>
          </form>

          <p id="success-message" style="display:none;color:#789476;background:#ddedd5;font-size:10px;padding:5px;">
            ${T.ok1}<br>${T.ok2}
          </p>
          <p class="small-print" style="font-size:12px;color:#777;margin-top:15px;">${T.small}</p>
        </div>`;
      document.body.appendChild(wrap);
    },

    setTitle(variantName = '') {
      const el = document.getElementById('product-name');
      if (!el) return;
      const out = variantName ? variantName.replace(/(\d+)$/, T.sizeWord + '$1') : '';
      el.textContent = out;
      el.style.marginBottom = '20px';
    },

    open(variant, productId) {
      this.ensureMarkup();
      const overlay = document.getElementById('overlay');
      const popup = document.getElementById('back-in-stock-popup');
      const btn = document.getElementById('back-in-stock-btn');
      const inProd = document.getElementById('productId');
      const inVar = document.getElementById('variantId');

      if (!overlay || !popup || !btn || !inProd || !inVar) return;

      btn.removeAttribute('disabled');
      inProd.value = productId || '';
      inVar.value = variant?.id || '';
      this.setTitle(variant?.name || '');

      popup.style.display = 'flex';
      overlay.style.display = 'block';
    },

    close() {
      const overlay = document.getElementById('overlay');
      const popup = document.getElementById('back-in-stock-popup');
      if (popup) popup.style.display = 'none';
      if (overlay) overlay.style.display = 'none';
      const ok = document.getElementById('success-message');
      if (ok) ok.style.display = 'none';
    },

    // ✅ AJOUT: fallback robuste pour récupérer le productId dans un layout "card"
    resolveProductIdFallback(btn) {
      // Scope: card / bloc produit autour du bouton
      const card = btn.closest('product-card, [data-current-product], .shop__grid-item, [data-id]');
      if (card) {
        // a) <product-form data-product-id> dans ce card
        const pf = card.querySelector('product-form[data-product-id]');
        if (pf) return pf.getAttribute('data-product-id');

        // b) data-id sur <product-card> (souvent = productId)
        const dataId = card.getAttribute('data-id');
        if (dataId) return dataId;

        // c) data-current-product (JSON possiblement encodé)
        let cp = card.dataset?.currentProduct || card.getAttribute('data-current-product');
        if (cp) {
          try {
            const obj = JSON.parse(cp);
            if (obj?.id) return String(obj.id);
          } catch {}
        }
      }

      // d) fallback: siblings <product-form> autour du bouton
      let sib = btn.previousElementSibling;
      while (sib) {
        if (sib.matches?.('product-form[data-product-id]')) {
          return sib.getAttribute('data-product-id');
        }
        sib = sib.previousElementSibling;
      }
      sib = btn.nextElementSibling;
      while (sib) {
        if (sib.matches?.('product-form[data-product-id]')) {
          return sib.getAttribute('data-product-id');
        }
        sib = sib.nextElementSibling;
      }

      return '';
    },

    bindOnce() {
      // Délégation globale : clique sur n’importe quel bouton `.back-in-stock-button`
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.back-in-stock-button');
        if (!btn) return;

        e.preventDefault();
        let raw = btn.getAttribute('data-variant');
        let variant;
        try { variant = JSON.parse(raw); }
        catch { variant = { id: raw, name: btn.dataset.variantName || '' }; }

        let productId =
          btn.getAttribute('data-product-id') || btn.getAttribute('data-id') ||
          btn.closest('[data-product-id]')?.getAttribute('data-product-id') ||
          '';

        // ✅ AJOUT: si rien trouvé, on tente le fallback scoping card
        if (!productId) {
          productId = this.resolveProductIdFallback(btn);
        }

        this.open(variant, productId);
      });

      // Fermer (croix + overlay)
      document.addEventListener('click', (e) => {
        if (e.target.id === 'overlay' || e.target.closest('#close-popup')) this.close();
      });

      // Submit
      const attachSubmit = () => {
        const form = document.getElementById('back-in-stock-form');
        if (!form || form.dataset.listenerAdded) return;
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const submitBtn = document.getElementById('back-in-stock-btn');
          const email = document.getElementById('customer-email')?.value || '';
          const productId = document.getElementById('productId')?.value || '';
          const variantId = document.getElementById('variantId')?.value || '';
          if (!email || !productId || !variantId) { alert(T.fill); return; }

          submitBtn?.setAttribute('disabled','true');
          const shopName = (window.Shopify && Shopify.shop) ? Shopify.shop : location.hostname;

          fetch('https://api.ranko.fr/shopify/customer/add-tag', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'db': 'izac' },
            body: JSON.stringify({ email, productId, variantId, shopName })
          })
          .then(r => r.json())
          .then(data => {
            if (data?.success) {
              const ok = document.getElementById('success-message');
              if (ok) ok.style.display = 'block';
            } else {
              alert(T.err);
              submitBtn?.removeAttribute('disabled');
            }
          })
          .catch(err => {
            console.error('Erreur:', err);
            alert(T.err);
            submitBtn?.removeAttribute('disabled');
          });
        });
        form.dataset.listenerAdded = '1';
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attachSubmit);
      } else {
        attachSubmit();
      }
    },

    boot() {
      if (this.booted) return;
      this.ensureMarkup();
      this.bindOnce();
      this.booted = true;
    }
  });

  // Compat: si ton code appelle encore initBackInStockListeners()
  window.initBackInStockListeners = () => mgr.boot();

  // Boot auto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mgr.boot());
  } else {
    mgr.boot();
  }
})();
